import { createApiRequest } from "@/lib/api/createApiService";
import { GElement_ENDPOINTS } from "./gElement.endpoints";

export const gElementService = {
  fetchMeasurementData: async (payload, options = {}) => {
    return createApiRequest({
      url: GElement_ENDPOINTS.GETMEASUREMENTDATA,
      method: "POST",
      body: payload,
      ...options,
    });
  },
  fetchEmissionData: async (payload, params, options = {}) => {
    return createApiRequest({
      url: `${GElement_ENDPOINTS.GETEMISSIONDATA}?${params}`,
      method: "POST",
      body: payload,
      ...options,
    });
  },
  publishToSenfi: async (payload, options = {}) => {
    return createApiRequest({
      url: GElement_ENDPOINTS.PUBLISH_TO_SENFI,
      method: "POST",
      body: payload,
      ...options,
    });
  },
};
